/**
 * The message a failed sync row carries: `errors` holds one `{ error, prospectId }` per record
 * that failed, and the table shows the first (PREC-4301). The HubSpot and Pipedrive Sync Logs tabs
 * both read it (PREC-4428). `null` when the row has none.
 */
export const firstSyncLogError = (log: {
	errors?: readonly ({ error?: string; prospectId?: number } | null | undefined)[] | null;
}): string | null => {
	const message = log.errors?.find((entry) => entry?.error?.trim())?.error?.trim();

	return message || null;
};

/** The 1-based range a page shows, for "from–to of total"; `null` when there is nothing to show. */
export const syncLogPageRange = (
	offset: number,
	count: number,
	total: number
): { from: number; to: number; total: number } | null =>
	count > 0 ? { from: offset + 1, to: offset + count, total } : null;
